import Vue from "vue";

import url from "./url";
Vue.filter("url", url);
